var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("我的主控台")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText("download_file.list_title", "資料匯出")) + " ")])], 1)], 1)])]), _c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between col-12"
  }, [_c('h4', {
    staticClass: "col-4 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.displayText("download_file.list_title", "資料匯出")) + " ")]), _c('div', {
    staticClass: "col-2"
  }, [_c('b-button', {
    staticClass: "float-right btn-inverse-success",
    on: {
      "click": _vm.fetchDownloadFiles
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-lg"
  }), _vm._v(" 重新整理(" + _vm._s(_vm.remainingSeconds) + ") ")])], 1)]), _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.downloadFiles,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(action)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "row",
          staticStyle: {
            "gap": "0.5rem"
          }
        }, [_vm.checkPermission([_vm.consts.MY_EXPORT]) && data.item.status === 'processing' ? _c('b-button', {
          attrs: {
            "variant": "inverse-info"
          }
        }, [_c('span', {
          staticClass: "mdi mdi-autorenew"
        }), _vm._v(" " + _vm._s(_vm.displayText("download_file.field_status_processing", "處理中")) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.MY_EXPORT]) && data.item.status === 'completed' && _vm.checkDate(data.item.expired_at) ? _c('b-button', {
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'MyConsoleDownloadFileGetFile',
              params: {
                download_file_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-cloud-download"
        }), _vm._v(" " + _vm._s(_vm.displayText("download_file.download_file_button_text", "下載檔案")) + " ")]) : _vm._e(), _c('div', [data.item.show_password && data.item.password != null ? _c('b-button', {
          directives: [{
            name: "clipboard",
            rawName: "v-clipboard:copy",
            value: data.item.password,
            expression: "data.item.password",
            arg: "copy"
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.click",
            value: _vm.displayText('download_file.copy_success_text', '已複製'),
            expression: "\n                        displayText(\n                          'download_file.copy_success_text',\n                          '已複製'\n                        )\n                      ",
            modifiers: {
              "click": true
            }
          }],
          staticClass: "btn-outline-dark",
          attrs: {
            "id": "copy-tooltip-target",
            "variant": "outline-info"
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v("  " + _vm._s(data.item.password) + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.MY_EXPORT]) && data.item.status === 'completed' && !data.item.show_password && data.item.password && _vm.checkDate(data.item.expired_at) ? _c('b-button', {
          directives: [{
            name: "clipboard",
            rawName: "v-clipboard:copy",
            value: data.item.password,
            expression: "data.item.password",
            arg: "copy"
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.click",
            value: _vm.displayText('download_file.copy_success_text', '已複製'),
            expression: "\n                        displayText(\n                          'download_file.copy_success_text',\n                          '已複製'\n                        )\n                      ",
            modifiers: {
              "click": true
            }
          }],
          staticClass: "btn-inverse-dark",
          on: {
            "click": function click($event) {
              data.item.show_password = true;
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye-off"
        }), _vm._v(" " + _vm._s(_vm.displayText("download_file.show_download_file_password_text", "顯示密碼")) + " ")]) : _vm._e()], 1)], 1)];
      }
    }, {
      key: "cell(during_at)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(" " + _vm._s(_vm.formatDatetime(data.item.completed_at)) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.formatDatetime(data.item.expired_at)) + " ")])];
      }
    }, {
      key: "cell(creator_info)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(" " + _vm._s(data.item.staff_name) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.formatDatetime(data.item.created_at)) + " ")])];
      }
    }])
  })], 1)], 1), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }